import { COLOR_CODE } from "./constants";

type Marker = {
  [key: string]: Array<any>;
};

type Tag = {
  count: number;
  text: string;
  color: any;
  key: string;
};

type Tags = {
  all?: Tag;
  [key: string]: Tag;
};

const sortOrder = {
  all: 0,
  pending: 1,
  rto: 2,
  rescheduled: 3,
};

export const getAllTags = (markers: Marker): Tag[] => {
  const tags: Tags = {};
  Object.keys(markers).forEach((key) => {
    if (markers[key].length) {
      if (tags.all) {
        tags.all.count += markers[key].length;
      } else {
        tags.all = {
          count: markers[key].length,
          text: "All",
          color: COLOR_CODE.all,
          key: "all",
        };
      }
      tags[key] = {
        count: markers[key].length,
        text: key[0].toUpperCase() + key.slice(1),
        color: COLOR_CODE[key],
        key,
      };
    }
  });

  const resTags = Object.values(tags).sort(
    (a, b) => sortOrder[a.key] - sortOrder[b.key],
  );
  return resTags;
};
